import { createSlice } from '@reduxjs/toolkit'

export const AppConfigSlice = createSlice({
  name: 'appConfigInfo',
  initialState: {
    isMobileView: false,
    formData: {},
  },
  reducers: {
    setIsMobileView: (state, action) => {
      state.isMobileView = action.payload
    },
    setFormData: (state, action) => {
      const { code, value } = action.payload;
      state.formData[code] = value;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setIsMobileView, setFormData } = AppConfigSlice.actions

export default AppConfigSlice.reducer